import { get, post } from './requests'

export const getReportsListService = key => params => {
  return get(['reports'], { key, transformPayload: true, params })
}

export const getReportByIdService = key => reportId => get(['reports', reportId], { key })

export const getReportsByFiltersService = key => (reportId, payload) =>
  post(['reports', reportId, 'execute_report_query'], { key }, payload)
